import React from 'react';
import './Footer.css';

const Footer = props => {

    return (
        <div id="footer">
            <div className="footer-primary-det">
                <span>
                    <a target="_blank" href="https://www.google.com/maps/place/Audigo+Global+Solutions/@13.0020374,77.5414205,15z/data=!4m5!3m4!1s0x0:0x6796da8583ec6f50!8m2!3d13.0020374!4d77.5414205">
                        <p style={{"fontWeight":"600", "fontSize":"18px", "color":"var(--adg-primary-color)"}}>
                        <i className="fas fa-map-marker-alt"/>Audigo Global Solutions Pvt Ltd.
                        </p>
                    </a>
                    <p>No : 1403, 12 B Cross,</p>
                    <p>2nd Stage, West of Chord Road,</p>
                    <p>Mahalakshmipuram, Bangalore,</p>
                    <p>Karnataka 560086, India.</p>
                    <p style={{"color":"var(--adg-highlight-color)"}}>For any queries, please mail to <a href="mailto:info@audigosolutions.com" style={{"color":"var(--adg-highlight-color)"}}>info@audigosolutions.com</a> </p>
                </span>
                <span>
                    <i className="fab fa-facebook-square fa-2x"/>
                    <i className="fab fa-linkedin fa-2x"/>
                    <i className="fab fa-instagram fa-2x"/>
                    <i className="fab fa-twitter fa-2x"/>
                </span>
            </div>
            <hr />
            <div className="footer-details">
                <span>Copyrights &copy; 2019-2021 Audigo Global Solutions Pvt Ltd.</span>
                <span>
                    <a>Privacy Policy</a>
                    <a>Terms & Conditions</a>
                </span>
            </div>
        </div>
    );

};

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js